import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import {
  getPrice,
  updatePrice,
  getOurReport,
getOurNewReport,
  getLedger,
  getDashboard,
  sendOtpDownload,
  verifyOtpDownload,
  getOrgTransactionsSummary,
} from './overviewMiddleware';

export const updatePriceAction = async (
  dispatch: AppDispatch,
  payload: { gold: number; silver: number, saleGold: number; saleSilver: number }
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updatePrice(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Price updated Successfully'));

    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(
      showErrorMessage(
        Boolean(res.payload?.response?.data?.message) ||
          'Error when updating price'
      )
    );
    return false;
  }
};

export const getPriceAction = async (dispatch: AppDispatch) => {
  const res = await dispatch(getPrice({}));
  console.log('res.data', res);
};

export const getOurReportAction = async (
  dispatch: AppDispatch,
  payload: { startDate: string; endDate: string }
) => {
  await dispatch(getOurReport(payload));
};

export const getOurNewReportAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  await dispatch(getOurNewReport(payload));
};

export const getDashboardAction = async (
  dispatch: AppDispatch,
  payload: { branch: string; startDate: string; endDate: string }
) => {
  await dispatch(getDashboard(payload));
};

export const getLedgerAction = async (
  dispatch: AppDispatch,
  payload: { branch: string }
) => {
  await dispatch(getLedger(payload));
};

export const sendOtpDownloadAction = async (
  dispatch: AppDispatch,
  payload: { type: string }
) => {
  const res: any = await dispatch(sendOtpDownload(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('OTP sent successfully'));
    return res.payload;
  } else {
    dispatch(
      showErrorMessage(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        res.payload?.response?.data?.message || 'Failed to send OTP'
      )
    );
    return false;
  }
};

export const verifyOtpDownloadAction = async (
  dispatch: AppDispatch,
  payload: { type: string; otp: string }
) => {
  const res: any = await dispatch(verifyOtpDownload(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('OTP verified successfully'));
    return res.payload;
  } else {
    dispatch(
      showErrorMessage(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        res.payload?.response?.data?.message || 'Failed to verify OTP'
      )
    );
    return false;
  }
};

export const getOrgTransactionsSummaryAction = async (
  dispatch: AppDispatch,
  payload: { branch: string; startDate: string; endDate: string }
) => {
  await dispatch(getOrgTransactionsSummary(payload));
};

